module.exports = __webpack_public_path__ + "img/4-1.443a03e9.gif";